import TerminalsForm from "./TerminalsForm";
import TerminalsTable from "./TerminalsTable";
import { ReduxAction, TerminalDataFields } from "../../types";
import * as Nested from "../../util/Nested";

interface State {
  terminals: TerminalDataFields[];
  terminalsCache: TerminalDataFields[];
}

const initialState: State = {
  terminals: [],
  terminalsCache: [], // Used to revert terminals to its previous state if drag and drop sort request errors
};

export const TERMINALS_FORM_ACTION = "posConfigTool/TERMINALS_FORM_ACTION";
export const terminalsFormAction = Nested.nestedAction(TERMINALS_FORM_ACTION);

export const TERMINALS_TABLE_ACTION = "posConfigTool/TERMINALS_TABLE_ACTION";
export const terminalsTableAction = Nested.nestedAction(TERMINALS_TABLE_ACTION);

const SET_TERMINALS = "SET_TERMINALS";
export const setTerminals = (terminals: TerminalDataFields[]) => ({
  type: SET_TERMINALS,
  payload: terminals,
});

const SET_TERMINALS_CACHE = "SET_TERMINALS_CACHE";
export const setTerminalsCache = (terminals: TerminalDataFields[]) => ({
  type: SET_TERMINALS_CACHE,
  payload: terminals,
});

const _reducer = (
  state: State = initialState,
  { type, payload }: ReduxAction
): State => {
  switch (type) {
    case SET_TERMINALS: {
      return {
        ...state,
        terminals: payload as TerminalDataFields[],
      };
    }
    case SET_TERMINALS_CACHE: {
      return {
        ...state,
        terminalsCache: payload as TerminalDataFields[],
      };
    }
    default:
      return state;
  }
};

// Raw Redux Maps
export const _mapStateToProps = () => {};
export const _mapDispatchToProps = () => {};

// Nested Redux Maps
const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    forms: {
      terminalsForm: {
        ...TerminalsForm,
        actionType: TERMINALS_FORM_ACTION,
      },
      terminalsTableForm: {
        ...TerminalsTable,
        actionType: TERMINALS_TABLE_ACTION,
      },
    },
  },
  "terminals"
);

// Nested Reducer
const reducer = (state: State, action: ReduxAction) => nestedReducer(state, action);
export { reducer, mapStateToProps, mapDispatchToProps };
